import { __extends } from 'tslib';
import * as React from 'react';
import { UitkIcon } from 'uitk-react-icons';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-switch.css';
var getClassNameList = classNames.bind(styles);
var UitkFavoriteSwitch = /** @class */function (_super) {
  __extends(UitkFavoriteSwitch, _super);
  function UitkFavoriteSwitch() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  UitkFavoriteSwitch.prototype.render = function () {
    var _a;
    var _b = this.props,
      checked = _b.checked,
      className = _b.className,
      disabled = _b.disabled,
      id = _b.id,
      label = _b.label,
      labelClassName = _b.labelClassName,
      name = _b.name,
      onChange = _b.onChange,
      value = _b.value;
    var baseClass = 'uitk-favorite-switch';
    var wrapperClassName = getClassNameList(baseClass, {
      'is-disabled': disabled
    });
    var inputClassNames = getClassNameList(className, "".concat(baseClass, "-input"));
    var labelCssClassName = getClassNameList(labelClassName, "".concat(baseClass, "-control"), (_a = {}, _a["".concat(baseClass, "-input-is-checked")] = checked, _a));
    var fillCssClassName = getClassNameList("".concat(baseClass, "-fill"));
    var borderCssClassName = getClassNameList("".concat(baseClass, "-border"));
    return React.createElement("div", {
      className: wrapperClassName
    }, React.createElement("label", {
      className: labelCssClassName,
      htmlFor: id
    }, React.createElement("input", {
      className: inputClassNames,
      type: "checkbox",
      name: name || id,
      id: id,
      checked: checked,
      onChange: onChange,
      value: value,
      "aria-label": label,
      disabled: disabled
    }), React.createElement(UitkIcon, {
      name: "favorite",
      className: fillCssClassName
    }), React.createElement(UitkIcon, {
      name: "favorite_border",
      className: borderCssClassName
    })));
  };
  UitkFavoriteSwitch.displayName = 'UitkFavoriteSwitch';
  UitkFavoriteSwitch.defaultProps = {
    checked: false
  };
  return UitkFavoriteSwitch;
}(React.Component);
export { UitkFavoriteSwitch };